import { render, staticRenderFns } from "./myDonate.vue?vue&type=template&id=1d47c002&scoped=true&"
import script from "./myDonate.vue?vue&type=script&lang=js&"
export * from "./myDonate.vue?vue&type=script&lang=js&"
import style0 from "./myDonate.vue?vue&type=style&index=0&id=1d47c002&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d47c002",
  null
  
)

export default component.exports